// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './style/base.css'
import './style/common.css'
import './style/iconfont_xiaoshi/iconfont.css'
import './style/common-iconfont.css'
import store from './store'
import 'babel-polyfill';
import publicMethod from './utils/publicMethod'
import directive from './utils/directives'
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn'
import {hasPermission} from './utils/hasPermission'
import $ from "jquery";
import { get, post, qspost, newPost } from "@/http/axios"; 
import Pagination from "./components/Pagination";
import { parseTime, selectDictLabel} from './utils/funs.js';


import { _debounce, debounce } from "@/utils/utils.js";

import JSEncrypt from 'jsencrypt';//引入加密模块
Vue.prototype.$jsEncrypt = JSEncrypt;//配置全局变量

// 引入vue3的composition-api 为以后迁移升级做准备
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)
dayjs.locale('zh-cn') // 全局使用
// 注册全局变量原型testPMethod
Vue.prototype.debounce = debounce
Vue.prototype.publicMethod = publicMethod
Vue.prototype.$http = axios
Vue.prototype.$dayjs = dayjs
Vue.prototype.hasPerm = hasPermission
import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上
Vue.use(ElementUI);
// 自定义全局指令，用于显示表格加载
Vue.directive('loading-class', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    el.parentElement.className += " table-loading-parent";
  }
})

// 扩展全局键盘回车事件
Vue.prototype.$keyEnter = function (vm,functionname,type) {
  document.onkeydown = function(e) {
      let key = window.event.keyCode;
      if (key === 13) {
          window.event.preventDefault() //关闭浏览器快捷键
          vm[functionname](type);
      }
  };
}

// el-select 下拉分页加载数据
Vue.use(directive)

// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.selectDictLabel = selectDictLabel

// 全局组件挂载
Vue.component('Pagination', Pagination)

// 引入Echarts
// import echarts from 'echarts'
// import * as echarts from "echarts";
// Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
Vue.prototype.baseUrl = process.env.NODE_ENV==="production"?"http://192.168.0.86:8088/":"/api"

window.$router = router;  //挂载全局变量，解决vue2项目使用composition api使用router需要升级router版本的问题
window.$store = store;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js